import { postQueries } from "@circle-react/lib/queries/posts";
import { useQuery, useQueryClient } from "react-query";

export const usePostResource = ({
  spaceId,
  postSlug,
  spaceSlug = "",
  queryOptions = {},
  disabled = false,
}) => {
  const query = postQueries.postDetails({ spaceId, spaceSlug, postSlug });

  const { data, error, isInitialLoading, isPending, refetch, status } =
    useQuery({
      ...query,
      enabled: !disabled && !!((spaceId || spaceSlug) && postSlug),
      staleTime: 0,
      ...queryOptions,
      retry: (_, error) => ![401, 404].includes(error?.status),
    });

  const queryClient = useQueryClient();
  const onPostChange = async (post, { refetch: shouldRefetch = true } = {}) =>
    !shouldRefetch
      ? queryClient.setQueryData(query.queryKey, () => post)
      : refetch();

  return {
    data,
    error,
    isInitialLoading,
    isPending,
    onPostChange,
    post: data,
    refetch,
    status,
  };
};
